import script from "./TableBreadCrumbs.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableBreadCrumbs.vue?vue&type=script&lang=ts&setup=true"

import "./TableBreadCrumbs.vue?vue&type=style&index=0&id=724edc2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-724edc2e"]])

export default __exports__